
import { API } from '@/utils'

import * as http from '@/utils/unrestrictedAPI'

export default {
	state: {
		status: '',
		//token: localStorage.getItem('user-token') || '',
		//user: JSON.parse(localStorage.getItem('mz-admin-user')) || null,
		token: localStorage.getItem('_mz_admin_token') || '',
		user: JSON.parse(localStorage.getItem('user')) || '',
		phone: ''
	},

	mutations: {
		SET_PHONE(state, payload) {
			state.phone = payload
		},
		SET_USER(state, payload) {
			state.user = payload
		},
		SET_TOKEN(state, payload) {
			state.token = payload
		},
		STATUS_READY(state) {
			state.status = 'ready'
		},
		STATUS_LOADING(state) {
			state.status = 'laoding'
		},
		STATUS_ERROR(state, error) {
			state.status = {
				stat: 'error',
				message: error
			}
		},

		logOut(state, payload = null) {
			state.user = payload
		}
	},

	actions: {
		LOGIN_REQUEST({ commit, dispatch }, data) {
		    return new Promise( (resolve, reject) => {
		        return http.login(data)
		            .then((r) => {
		                // dispatch('UPDATE_TOKEN', r.data.token)
		                dispatch('SET_PHONE', data.phone)
		                resolve(r)
		            })
		            .catch((err) => {
		                reject(err)
		            })
		    })
		},

		VERIFY_REQUEST({ commit, dispatch }, data) {
		    return new Promise( (resolve, reject) => {
		        return http.verify(data)
		            .then( (r) => {
		                dispatch('UPDATE_TOKEN', r.data.token)
		                dispatch('SET_USER', r.data.user)
		                resolve(r)
		            })
		            .catch( (err) => {
		                reject(err)
		            })
		    })
		},

		UPDATE_TOKEN({ commit }, token) {
		    localStorage.setItem('_mz_admin_token', token)
		},

		SET_USER ({ commit }, user) {
		    commit('SET_USER', user)
		    localStorage.setItem('user', JSON.stringify(user))
		},

		DELETE_UNREGISTERED_USER ({ commit }) { //@depreacated
		    localStorage.removeItem('user')
		    localStorage.removeItem('_mz_admin_token')
		    commit('logOut')
		    //commit('SET_REG_TOKEN', null)
		    //commit('BACKWARD', 1)
		},

		/*
		AUTH_REQUEST({ commit }, user) {
			return new Promise((resolve, reject) => {
				SIGN.post('/auth/login', user)
					.then( response => {
						localStorage.setItem('mz-admin-user', JSON.stringify(response.data.user))
						commit('SET_USER', response.data.user)
						resolve()
					})
					.catch( e => {
						throw e
						reject()
					})
			})
		},
		*/

		GET_USER_LIST({ commit }) {
			return API.get('/user/list')
			.then( users => {
				return users.data
			})
			.catch( err => {
				throw err
			})
		},

    GET_CAPTCHA () {
      return http.captcha()
			.then( res => {
				return res.data
			})
			.catch( err => {
				throw err
			})
    },
    SEND_CAPTCHA({ commit, dispatch }, data) {
      return new Promise( (resolve, reject) => {
        return http.sendCaptcha(data)
        .then((r) => {
          resolve(r)
        })
        .catch((err) => {
          reject(err)
        })
      })
  },

		UPD_USER_STATUS({ commit }, dataObj) {
			return API.post('user/status/update', {
				phone: dataObj.phone,
				newStatus: dataObj.newStatus
			})
			.then( (result) => {
				return result.data
			})
			.catch( (err) => {
				throw err
			})
		},

        USER_LOGOUT({ commit }) {
             commit('logOut')
             localStorage.removeItem('_mz_admin_token')
        }
	},

	getters: {
		getUser(state) {
			return state.user
		},

		getUsername(state) {
			if (state.user !== null) {
				return state.user.name
			}
		},

		GET_PHONE(state) {
			return state.phone
		},

		GET_USER_TOKEN(state) {
			return state.token
		}
	}
}


